import React, { Component } from "react";
import { Row, Col, Table, Tooltip, OverlayTrigger } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import CustomButtom from "components/CustomButton/CustomButton.jsx";
import { fetchPayscalesRequest, deletePayscaleRequest } from "../../../api/payscale";
import moment from "moment";

class PayscaleTable extends Component {

  state = {
    data: null,
    error: null,
    loading: false,
    selectedLocation: this.props.selectedLocation,
    selectedEffectiveDate: this.props.selectedEffectiveDate
  };

  componentDidMount() {
    this.fetchPayscaleData(this.props.selectedLocation, this.props.selectedEffectiveDate)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.fetchPayscaleData(nextProps.selectedLocation, nextProps.selectedEffectiveDate)
  }

  fetchPayscaleData(selectedLocation, selectedEffectiveDate){
    this.setState({
      loading: true
    });
    fetchPayscalesRequest(selectedLocation, selectedEffectiveDate, 
      result => this.setState({data: result, error: null, loading: false}),
      error => this.setState({error: error.message, loading: false})
    )
  };

  deletePayscale = (id) => {
    deletePayscaleRequest(
      id,
      result => this.fetchPayscaleData(this.props.selectedLocation, this.props.selectedEffectiveDate),
      error =>
        this.setState({ error: "There was an error deleting instance" })
    );
  
  }

  render() {
    const { data } = this.state;
    const { selectedEffectiveDate } = this.props;
    const view = <Tooltip id="view_tooltip">View</Tooltip>;
    const edit = <Tooltip id="edit_tooltip">Edit</Tooltip>;
    const remove = <Tooltip id="remove_tooltip">Remove</Tooltip>;


    return (
      <div className="content">
          <Row>
            <Col md={12}>
              <Card
                title="Payscale Table"
                category="List of Payscale entries to DB"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div>
                    <CustomButtom className="table-top-btn btn-primary" onClick={() => this.props.goToCreateForm('payscale')}>
                      New Group
                    </CustomButtom>
                    {!!selectedEffectiveDate && 
                      <Table striped hover>
                        <thead>
                          <tr>
                            <th>Level</th>
                            <th>Basic Wage</th>
                            <th>ECOLA</th>
                            <th>Monthly Wage</th>
                            <th>Daily Rate</th>
                            <th>Area</th>
                            <th>Effective Date</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading ?
                            <td colSpan="8" style={{padding: "0"}}>
                              <div className="loader"></div>
                            </td> 
                            :
                            (data && data.length > 0) 
                            ? data.map(instance => {
                              return (
                                <tr key={instance._id}>
                                  <td>{instance.level?.payLevelName ? `${instance.level.payLevelName} - ${instance.level.area.areaName}` : "N/A"}</td>
                                  <td>{instance.basicWage || "N/A"}</td>
                                  <td>{instance.ecola || "N/A"}</td>
                                  <td>{instance.monthlyWage || "N/A"}</td>
                                  <td>{instance.dailyRate || "N/A"}</td>
                                  <td>{instance.area ? instance.area.areaName : "N/A"}</td>
                                  <td>{moment.utc(instance.effectiveDate).format('YYYY-MM-DD') || "N/A"}</td>
                                  <td className="td-actions text-right">
                                    <OverlayTrigger placement="top" overlay={view}>
                                      <CustomButtom 
                                        bsStyle="success" 
                                        simple 
                                        type="button" 
                                        bsSize="xs"
                                        onClick={() => this.props.goToDetails('payscale', instance._id)}
                                      >
                                        <i className="fa fa-eye" />
                                      </CustomButtom>
                                    </OverlayTrigger>

                                    <OverlayTrigger placement="top" overlay={edit}>
                                      <CustomButtom 
                                        bsStyle="info" 
                                        simple 
                                        type="button" 
                                        bsSize="xs"
                                        onClick={() => this.props.goToEditForm('payscale', instance._id)}
                                      >
                                        <i className="fa fa-edit" />
                                      </CustomButtom>
                                    </OverlayTrigger>

                                    <OverlayTrigger placement="top" overlay={remove}>
                                      <CustomButtom 
                                        bsStyle="danger" 
                                        simple 
                                        type="button" 
                                        bsSize="xs"
                                        onClick={() => this.deletePayscale(instance._id)}
                                      >
                                        <i className="fa fa-times" />
                                      </CustomButtom>
                                    </OverlayTrigger>
                                  </td>
                                </tr>
                              )}
                            )
                            : (
                              <tr>
                                <td colSpan='8'>There are no instances in the database yet.</td>
                              </tr>
                            )
                          }
                        </tbody>
                      </Table>
                    }
                  </div>
                }
              />
            </Col>
          </Row>
      </div>
    );
  }
}

export default PayscaleTable;
